<template>
  <div class="account-boxes">
    <DeployerUiBox
      :box-title="texts.box_help.title"
      :box-text="texts.box_help.text"
    >
      <DeployerAccountGetHelp />
    </DeployerUiBox>

    <DeployerUiBox
      :box-title="texts.box_feedback.title"
      :box-text="texts.box_feedback.text"
    >
      <DeployerAccountFeedbackForm />
    </DeployerUiBox>
  </div>
</template>

<script setup>
const textsStore = useTextsStore()
const texts = computed(() => textsStore.account.support)
</script>

<style lang="scss" scoped></style>
